import React from 'react';

import ResourceGroup from '../ResourceGroup';
import Vehicle from './Vehicle';

export default class Vehicles extends React.PureComponent {
    
    render() {
        const {
            ravens,
            ...rest
        } = this.props;

        // Ravens without tags are not shown in the vehicles list
        // https://docs.google.com/document/d/1aJn1eYjLToDFDTYW1VvC4u6x8TN6xo1xeiLFUlbItPE/edit?tab=t.0#bookmark=id.5a0d8l38a0ri
        const ravensWithTag = ravens.filter(raven => raven.tags && raven.tags.length > 0);

        return (
            <ResourceGroup
                type='vehicle'
                items={ravensWithTag}
                itemFactory={itemFactory}
                {...rest}
            />
        );
    }

}

const itemFactory = (raven, props) => (
    <Vehicle
        key={raven.ravenUuid}
        raven={raven}
        tags={raven.tags} // pass tags separately because the pure component is not detecting changes in nested objects (raven.tags) and not re-rendering when tags are added/removed/edited.
        warningLevel={props.warningLevel}
        features={props.features}
        vehicleState={raven.vehicleState} 
        currentSpeed={raven.vehicleState && raven.vehicleState.currentSpeed}
        unplugged={raven.unplugged}
        isIdling={raven.isIdling}
        sdCardStatus={raven.sdCardStatus}
        selected={props.selectedId === raven.ravenUuid} 
        onSelectResource={props.onSelectResource}
        setVisible={props.setVisible}
        editingVehicleName={props.editingNameFor === raven}
        vehicleNameChangePending={!!raven.vehicle._pendingName}
        setEditingVehicleName={props.setEditingItemName}
        changeVehicleName={props.changeVehicleName}
        hidden={raven.hidden}
        unitOfMeasure={props.unitOfMeasure}
        theme={props.theme}
        badgesView={props.badgesView}
    />
);
